import { type FC, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './applicationCard.css';
import {type EnvironmentClass, type ApplicationDto} from '@/models/services.ts'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { StatisticsService } from '@/services/StatisticsService';
import type { Statistic, StatisticsUptimeDto } from '@/models/statisticsUptime';

type StatisticsSimpleUptimeProps = {
    statistic?: Statistic;
};

const StatisticsSimpleUptime: FC<StatisticsSimpleUptimeProps> = ({ statistic }: StatisticsSimpleUptimeProps) => {
  
    
const CustomTooltip = ({ active, payload, label, statistic }) => {
    let isVisible = active && payload && payload.length;
    return (
      <div className="tooltip-custom-style" style={{ visibility: isVisible ? 'visible' : 'hidden' }}>
        {isVisible && (
          <>
            <p className="label">{`Time: ${payload[0].payload.dateFormatted}`}</p>
            <p className="label">{`Down : ${payload[0].value} times`}</p>
          </>
        )}
      </div>
    );
  };

    return (
        statistic != null ?
            <div style={{ width: '100%', height: 10 }}>
            <ResponsiveContainer width="100%" height="100%">
            <BarChart
                data={statistic.uptimes}
                margin={{
                top: 0,
                right: 0,
                left: 0,
                bottom: 0,
                }}
            >
                <Tooltip animationDuration={500} wrapperClassName='tooltip-custom-style'  content={CustomTooltip}  />
                <Bar dataKey="countDown" stackId="a" fill="#ff3333" />
                {/* <Bar dataKey="up" stackId="a" fill="#eee" /> */}
            </BarChart>
            </ResponsiveContainer>
            </div> : null 
)
};

export default StatisticsSimpleUptime;

